module.exports = __webpack_public_path__ + "img/2d480ee0c2af43d1b67d747a1c5cc38d.b2202761.png";